// Country codes from the public-domain IANA iso3166.tab; labels from Intl.DisplayNames.
const countries = [
  {"code":"AD","nl":"Andorra","en":"Andorra"},
  {"code":"AE","nl":"Verenigde Arabische Emiraten","en":"United Arab Emirates"},
  {"code":"AF","nl":"Afghanistan","en":"Afghanistan"},
  {"code":"AG","nl":"Antigua en Barbuda","en":"Antigua & Barbuda"},
  {"code":"AI","nl":"Anguilla","en":"Anguilla"},
  {"code":"AL","nl":"Albanië","en":"Albania"},
  {"code":"AM","nl":"Armenië","en":"Armenia"},
  {"code":"AO","nl":"Angola","en":"Angola"},
  {"code":"AQ","nl":"Antarctica","en":"Antarctica"},
  {"code":"AR","nl":"Argentinië","en":"Argentina"},
  {"code":"AS","nl":"Amerikaans-Samoa","en":"American Samoa"},
  {"code":"AT","nl":"Oostenrijk","en":"Austria"},
  {"code":"AU","nl":"Australië","en":"Australia"},
  {"code":"AW","nl":"Aruba","en":"Aruba"},
  {"code":"AX","nl":"Åland","en":"Åland Islands"},
  {"code":"AZ","nl":"Azerbeidzjan","en":"Azerbaijan"},
  {"code":"BA","nl":"Bosnië en Herzegovina","en":"Bosnia & Herzegovina"},
  {"code":"BB","nl":"Barbados","en":"Barbados"},
  {"code":"BD","nl":"Bangladesh","en":"Bangladesh"},
  {"code":"BE","nl":"België","en":"Belgium"},
  {"code":"BF","nl":"Burkina Faso","en":"Burkina Faso"},
  {"code":"BG","nl":"Bulgarije","en":"Bulgaria"},
  {"code":"BH","nl":"Bahrein","en":"Bahrain"},
  {"code":"BI","nl":"Burundi","en":"Burundi"},
  {"code":"BJ","nl":"Benin","en":"Benin"},
  {"code":"BL","nl":"Saint-Barthélemy","en":"St. Barthélemy"},
  {"code":"BM","nl":"Bermuda","en":"Bermuda"},
  {"code":"BN","nl":"Brunei","en":"Brunei"},
  {"code":"BO","nl":"Bolivia","en":"Bolivia"},
  {"code":"BQ","nl":"Caribisch Nederland","en":"Caribbean Netherlands"},
  {"code":"BR","nl":"Brazilië","en":"Brazil"},
  {"code":"BS","nl":"Bahama’s","en":"Bahamas"},
  {"code":"BT","nl":"Bhutan","en":"Bhutan"},
  {"code":"BV","nl":"Bouveteiland","en":"Bouvet Island"},
  {"code":"BW","nl":"Botswana","en":"Botswana"},
  {"code":"BY","nl":"Belarus","en":"Belarus"},
  {"code":"BZ","nl":"Belize","en":"Belize"},
  {"code":"CA","nl":"Canada","en":"Canada"},
  {"code":"CC","nl":"Cocoseilanden","en":"Cocos (Keeling) Islands"},
  {"code":"CD","nl":"Congo-Kinshasa","en":"Congo - Kinshasa"},
  {"code":"CF","nl":"Centraal-Afrikaanse Republiek","en":"Central African Republic"},
  {"code":"CG","nl":"Congo-Brazzaville","en":"Congo - Brazzaville"},
  {"code":"CH","nl":"Zwitserland","en":"Switzerland"},
  {"code":"CI","nl":"Ivoorkust","en":"Côte d’Ivoire"},
  {"code":"CK","nl":"Cookeilanden","en":"Cook Islands"},
  {"code":"CL","nl":"Chili","en":"Chile"},
  {"code":"CM","nl":"Kameroen","en":"Cameroon"},
  {"code":"CN","nl":"China","en":"China"},
  {"code":"CO","nl":"Colombia","en":"Colombia"},
  {"code":"CR","nl":"Costa Rica","en":"Costa Rica"},
  {"code":"CU","nl":"Cuba","en":"Cuba"},
  {"code":"CV","nl":"Kaapverdië","en":"Cape Verde"},
  {"code":"CW","nl":"Curaçao","en":"Curaçao"},
  {"code":"CX","nl":"Christmaseiland","en":"Christmas Island"},
  {"code":"CY","nl":"Cyprus","en":"Cyprus"},
  {"code":"CZ","nl":"Tsjechië","en":"Czechia"},
  {"code":"DE","nl":"Duitsland","en":"Germany"},
  {"code":"DJ","nl":"Djibouti","en":"Djibouti"},
  {"code":"DK","nl":"Denemarken","en":"Denmark"},
  {"code":"DM","nl":"Dominica","en":"Dominica"},
  {"code":"DO","nl":"Dominicaanse Republiek","en":"Dominican Republic"},
  {"code":"DZ","nl":"Algerije","en":"Algeria"},
  {"code":"EC","nl":"Ecuador","en":"Ecuador"},
  {"code":"EE","nl":"Estland","en":"Estonia"},
  {"code":"EG","nl":"Egypte","en":"Egypt"},
  {"code":"EH","nl":"Westelijke Sahara","en":"Western Sahara"},
  {"code":"ER","nl":"Eritrea","en":"Eritrea"},
  {"code":"ES","nl":"Spanje","en":"Spain"},
  {"code":"ET","nl":"Ethiopië","en":"Ethiopia"},
  {"code":"FI","nl":"Finland","en":"Finland"},
  {"code":"FJ","nl":"Fiji","en":"Fiji"},
  {"code":"FK","nl":"Falklandeilanden","en":"Falkland Islands"},
  {"code":"FM","nl":"Micronesia","en":"Micronesia"},
  {"code":"FO","nl":"Faeröer","en":"Faroe Islands"},
  {"code":"FR","nl":"Frankrijk","en":"France"},
  {"code":"GA","nl":"Gabon","en":"Gabon"},
  {"code":"GB","nl":"Verenigd Koninkrijk","en":"United Kingdom"},
  {"code":"GD","nl":"Grenada","en":"Grenada"},
  {"code":"GE","nl":"Georgië","en":"Georgia"},
  {"code":"GF","nl":"Frans-Guyana","en":"French Guiana"},
  {"code":"GG","nl":"Guernsey","en":"Guernsey"},
  {"code":"GH","nl":"Ghana","en":"Ghana"},
  {"code":"GI","nl":"Gibraltar","en":"Gibraltar"},
  {"code":"GL","nl":"Groenland","en":"Greenland"},
  {"code":"GM","nl":"Gambia","en":"Gambia"},
  {"code":"GN","nl":"Guinee","en":"Guinea"},
  {"code":"GP","nl":"Guadeloupe","en":"Guadeloupe"},
  {"code":"GQ","nl":"Equatoriaal-Guinea","en":"Equatorial Guinea"},
  {"code":"GR","nl":"Griekenland","en":"Greece"},
  {"code":"GS","nl":"Zuid-Georgia en Zuidelijke Sandwicheilanden","en":"South Georgia & South Sandwich Islands"},
  {"code":"GT","nl":"Guatemala","en":"Guatemala"},
  {"code":"GU","nl":"Guam","en":"Guam"},
  {"code":"GW","nl":"Guinee-Bissau","en":"Guinea-Bissau"},
  {"code":"GY","nl":"Guyana","en":"Guyana"},
  {"code":"HK","nl":"Hongkong SAR van China","en":"Hong Kong SAR China"},
  {"code":"HM","nl":"Heard en McDonaldeilanden","en":"Heard & McDonald Islands"},
  {"code":"HN","nl":"Honduras","en":"Honduras"},
  {"code":"HR","nl":"Kroatië","en":"Croatia"},
  {"code":"HT","nl":"Haïti","en":"Haiti"},
  {"code":"HU","nl":"Hongarije","en":"Hungary"},
  {"code":"ID","nl":"Indonesië","en":"Indonesia"},
  {"code":"IE","nl":"Ierland","en":"Ireland"},
  {"code":"IL","nl":"Israël","en":"Israel"},
  {"code":"IM","nl":"Isle of Man","en":"Isle of Man"},
  {"code":"IN","nl":"India","en":"India"},
  {"code":"IO","nl":"Brits Indische Oceaanterritorium","en":"British Indian Ocean Territory"},
  {"code":"IQ","nl":"Irak","en":"Iraq"},
  {"code":"IR","nl":"Iran","en":"Iran"},
  {"code":"IS","nl":"IJsland","en":"Iceland"},
  {"code":"IT","nl":"Italië","en":"Italy"},
  {"code":"JE","nl":"Jersey","en":"Jersey"},
  {"code":"JM","nl":"Jamaica","en":"Jamaica"},
  {"code":"JO","nl":"Jordanië","en":"Jordan"},
  {"code":"JP","nl":"Japan","en":"Japan"},
  {"code":"KE","nl":"Kenia","en":"Kenya"},
  {"code":"KG","nl":"Kirgizië","en":"Kyrgyzstan"},
  {"code":"KH","nl":"Cambodja","en":"Cambodia"},
  {"code":"KI","nl":"Kiribati","en":"Kiribati"},
  {"code":"KM","nl":"Comoren","en":"Comoros"},
  {"code":"KN","nl":"Saint Kitts en Nevis","en":"St. Kitts & Nevis"},
  {"code":"KP","nl":"Noord-Korea","en":"North Korea"},
  {"code":"KR","nl":"Zuid-Korea","en":"South Korea"},
  {"code":"KW","nl":"Koeweit","en":"Kuwait"},
  {"code":"KY","nl":"Kaaimaneilanden","en":"Cayman Islands"},
  {"code":"KZ","nl":"Kazachstan","en":"Kazakhstan"},
  {"code":"LA","nl":"Laos","en":"Laos"},
  {"code":"LB","nl":"Libanon","en":"Lebanon"},
  {"code":"LC","nl":"Saint Lucia","en":"St. Lucia"},
  {"code":"LI","nl":"Liechtenstein","en":"Liechtenstein"},
  {"code":"LK","nl":"Sri Lanka","en":"Sri Lanka"},
  {"code":"LR","nl":"Liberia","en":"Liberia"},
  {"code":"LS","nl":"Lesotho","en":"Lesotho"},
  {"code":"LT","nl":"Litouwen","en":"Lithuania"},
  {"code":"LU","nl":"Luxemburg","en":"Luxembourg"},
  {"code":"LV","nl":"Letland","en":"Latvia"},
  {"code":"LY","nl":"Libië","en":"Libya"},
  {"code":"MA","nl":"Marokko","en":"Morocco"},
  {"code":"MC","nl":"Monaco","en":"Monaco"},
  {"code":"MD","nl":"Moldavië","en":"Moldova"},
  {"code":"ME","nl":"Montenegro","en":"Montenegro"},
  {"code":"MF","nl":"Saint-Martin","en":"St. Martin"},
  {"code":"MG","nl":"Madagaskar","en":"Madagascar"},
  {"code":"MH","nl":"Marshalleilanden","en":"Marshall Islands"},
  {"code":"MK","nl":"Noord-Macedonië","en":"North Macedonia"},
  {"code":"ML","nl":"Mali","en":"Mali"},
  {"code":"MM","nl":"Myanmar (Birma)","en":"Myanmar (Burma)"},
  {"code":"MN","nl":"Mongolië","en":"Mongolia"},
  {"code":"MO","nl":"Macau SAR van China","en":"Macao SAR China"},
  {"code":"MP","nl":"Noordelijke Marianen","en":"Northern Mariana Islands"},
  {"code":"MQ","nl":"Martinique","en":"Martinique"},
  {"code":"MR","nl":"Mauritanië","en":"Mauritania"},
  {"code":"MS","nl":"Montserrat","en":"Montserrat"},
  {"code":"MT","nl":"Malta","en":"Malta"},
  {"code":"MU","nl":"Mauritius","en":"Mauritius"},
  {"code":"MV","nl":"Maldiven","en":"Maldives"},
  {"code":"MW","nl":"Malawi","en":"Malawi"},
  {"code":"MX","nl":"Mexico","en":"Mexico"},
  {"code":"MY","nl":"Maleisië","en":"Malaysia"},
  {"code":"MZ","nl":"Mozambique","en":"Mozambique"},
  {"code":"NA","nl":"Namibië","en":"Namibia"},
  {"code":"NC","nl":"Nieuw-Caledonië","en":"New Caledonia"},
  {"code":"NE","nl":"Niger","en":"Niger"},
  {"code":"NF","nl":"Norfolk","en":"Norfolk Island"},
  {"code":"NG","nl":"Nigeria","en":"Nigeria"},
  {"code":"NI","nl":"Nicaragua","en":"Nicaragua"},
  {"code":"NL","nl":"Nederland","en":"Netherlands"},
  {"code":"NO","nl":"Noorwegen","en":"Norway"},
  {"code":"NP","nl":"Nepal","en":"Nepal"},
  {"code":"NR","nl":"Nauru","en":"Nauru"},
  {"code":"NU","nl":"Niue","en":"Niue"},
  {"code":"NZ","nl":"Nieuw-Zeeland","en":"New Zealand"},
  {"code":"OM","nl":"Oman","en":"Oman"},
  {"code":"PA","nl":"Panama","en":"Panama"},
  {"code":"PE","nl":"Peru","en":"Peru"},
  {"code":"PF","nl":"Frans-Polynesië","en":"French Polynesia"},
  {"code":"PG","nl":"Papoea-Nieuw-Guinea","en":"Papua New Guinea"},
  {"code":"PH","nl":"Filipijnen","en":"Philippines"},
  {"code":"PK","nl":"Pakistan","en":"Pakistan"},
  {"code":"PL","nl":"Polen","en":"Poland"},
  {"code":"PM","nl":"Saint-Pierre en Miquelon","en":"St. Pierre & Miquelon"},
  {"code":"PN","nl":"Pitcairneilanden","en":"Pitcairn Islands"},
  {"code":"PR","nl":"Puerto Rico","en":"Puerto Rico"},
  {"code":"PS","nl":"Palestijnse gebieden","en":"Palestinian Territories"},
  {"code":"PT","nl":"Portugal","en":"Portugal"},
  {"code":"PW","nl":"Palau","en":"Palau"},
  {"code":"PY","nl":"Paraguay","en":"Paraguay"},
  {"code":"QA","nl":"Qatar","en":"Qatar"},
  {"code":"RE","nl":"Réunion","en":"Réunion"},
  {"code":"RO","nl":"Roemenië","en":"Romania"},
  {"code":"RS","nl":"Servië","en":"Serbia"},
  {"code":"RU","nl":"Rusland","en":"Russia"},
  {"code":"RW","nl":"Rwanda","en":"Rwanda"},
  {"code":"SA","nl":"Saoedi-Arabië","en":"Saudi Arabia"},
  {"code":"SB","nl":"Salomonseilanden","en":"Solomon Islands"},
  {"code":"SC","nl":"Seychellen","en":"Seychelles"},
  {"code":"SD","nl":"Soedan","en":"Sudan"},
  {"code":"SE","nl":"Zweden","en":"Sweden"},
  {"code":"SG","nl":"Singapore","en":"Singapore"},
  {"code":"SH","nl":"Sint-Helena","en":"St. Helena"},
  {"code":"SI","nl":"Slovenië","en":"Slovenia"},
  {"code":"SJ","nl":"Spitsbergen en Jan Mayen","en":"Svalbard & Jan Mayen"},
  {"code":"SK","nl":"Slowakije","en":"Slovakia"},
  {"code":"SL","nl":"Sierra Leone","en":"Sierra Leone"},
  {"code":"SM","nl":"San Marino","en":"San Marino"},
  {"code":"SN","nl":"Senegal","en":"Senegal"},
  {"code":"SO","nl":"Somalië","en":"Somalia"},
  {"code":"SR","nl":"Suriname","en":"Suriname"},
  {"code":"SS","nl":"Zuid-Soedan","en":"South Sudan"},
  {"code":"ST","nl":"Sao Tomé en Principe","en":"São Tomé & Príncipe"},
  {"code":"SV","nl":"El Salvador","en":"El Salvador"},
  {"code":"SX","nl":"Sint-Maarten","en":"Sint Maarten"},
  {"code":"SY","nl":"Syrië","en":"Syria"},
  {"code":"SZ","nl":"Eswatini","en":"Eswatini"},
  {"code":"TC","nl":"Turks- en Caicoseilanden","en":"Turks & Caicos Islands"},
  {"code":"TD","nl":"Tsjaad","en":"Chad"},
  {"code":"TF","nl":"Franse Gebieden in de zuidelijke Indische Oceaan","en":"French Southern Territories"},
  {"code":"TG","nl":"Togo","en":"Togo"},
  {"code":"TH","nl":"Thailand","en":"Thailand"},
  {"code":"TJ","nl":"Tadzjikistan","en":"Tajikistan"},
  {"code":"TK","nl":"Tokelau","en":"Tokelau"},
  {"code":"TL","nl":"Oost-Timor","en":"Timor-Leste"},
  {"code":"TM","nl":"Turkmenistan","en":"Turkmenistan"},
  {"code":"TN","nl":"Tunesië","en":"Tunisia"},
  {"code":"TO","nl":"Tonga","en":"Tonga"},
  {"code":"TR","nl":"Turkije","en":"Türkiye"},
  {"code":"TT","nl":"Trinidad en Tobago","en":"Trinidad & Tobago"},
  {"code":"TV","nl":"Tuvalu","en":"Tuvalu"},
  {"code":"TW","nl":"Taiwan","en":"Taiwan"},
  {"code":"TZ","nl":"Tanzania","en":"Tanzania"},
  {"code":"UA","nl":"Oekraïne","en":"Ukraine"},
  {"code":"UG","nl":"Oeganda","en":"Uganda"},
  {"code":"UM","nl":"Kleine afgelegen eilanden van de Verenigde Staten","en":"U.S. Outlying Islands"},
  {"code":"US","nl":"Verenigde Staten","en":"United States"},
  {"code":"UY","nl":"Uruguay","en":"Uruguay"},
  {"code":"UZ","nl":"Oezbekistan","en":"Uzbekistan"},
  {"code":"VA","nl":"Vaticaanstad","en":"Vatican City"},
  {"code":"VC","nl":"Saint Vincent en de Grenadines","en":"St. Vincent & Grenadines"},
  {"code":"VE","nl":"Venezuela","en":"Venezuela"},
  {"code":"VG","nl":"Britse Maagdeneilanden","en":"British Virgin Islands"},
  {"code":"VI","nl":"Amerikaanse Maagdeneilanden","en":"U.S. Virgin Islands"},
  {"code":"VN","nl":"Vietnam","en":"Vietnam"},
  {"code":"VU","nl":"Vanuatu","en":"Vanuatu"},
  {"code":"WF","nl":"Wallis en Futuna","en":"Wallis & Futuna"},
  {"code":"WS","nl":"Samoa","en":"Samoa"},
  {"code":"YE","nl":"Jemen","en":"Yemen"},
  {"code":"YT","nl":"Mayotte","en":"Mayotte"},
  {"code":"ZA","nl":"Zuid-Afrika","en":"South Africa"},
  {"code":"ZM","nl":"Zambia","en":"Zambia"},
  {"code":"ZW","nl":"Zimbabwe","en":"Zimbabwe"},
];

export const countryName = (name: string, locale = 'nl'): string => {
  const country = countries.find(country => country.en === name);
  return country ? (locale === 'nl' ? country.nl : country.en) : name;
};

const normalizeSearch = (value: string) => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();

export const countryOptions = (locale = 'nl', query = '') => countries.filter(country =>
  [country.en, country.nl, country.code].some(value => normalizeSearch(value).includes(normalizeSearch(query)))
).map(country => ({
  name: country.en, label: locale === 'nl' ? country.nl : country.en,
})).sort((a, b) => a.label.localeCompare(b.label, locale));

export const countryFlag = (name: string): string => {
  const country = countries.find(country => country.en === name);
  return country ? String.fromCodePoint(...[...country.code].map(letter => 0x1f1e6 + letter.charCodeAt(0) - 65)) : '';
};
